import React from 'react';
import { t } from 'ttag';

// Components
import ChecklistItem from './checklistItemComponent';

import style from './checklist.scss';

export default function ChecklistComponentView(props) {
    return (
        <div className={style.container}>
            <div className={style.title}>
                <h2>{t`Checkliste`}</h2>
            </div>
            <div className={style.items}>
                {props.stepList.map((item, key) => (
                    <ChecklistItem
                        name={item.name}
                        isActive={key === props.activeStep}
                        isDone={key < props.activeStep}
                        key={key}
                    />
                ))}
            </div>
        </div>
    );
}
